<template>
  <div>
    <div style="display: flex">
      <b>{{ $t('spareparts.danger.title') }}</b>
      <patternlib-icon
        style="margin-left: 5px"
        icon-name="warning"
        bold
        color="#E52828"
      ></patternlib-icon>
    </div>
    <div>
      {{ $t('spareparts.danger.text') }}
    </div>
    <div>
      <patternlib-link
        size="M"
        type="prominent"
        variant="cross"
        :label="$t('spareparts.danger.link')"
        :href="getWebsiteConfigPage('HauCustomerServiceUrl').value"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useDataStore } from '../stores/data';

  const dataStore = useDataStore();
  const { getWebsiteConfigPage } = dataStore;
</script>

<style scoped></style>
